<template>
  <div>
    <div class="row mb-4">
      <div class="col">
        <router-link to="/integrations" class="btn btn-secondary btn-no-r">
          Insigths
        </router-link>
        <router-link
          to="/integrations/ratings"
          class="btn btn-no-r btn-no-l btn-secondary"
        >
          Ratings
        </router-link>
        <router-link
          to="/integrations/posts/feed"
          class="btn btn-no-l btn-no-r"
          :class="activeMenu == 'feed' ? 'btn-primary' : 'btn-secondary'"
        >
          Posts
        </router-link>
        <router-link
          to="/integrations/posts/tagged"
          class="btn btn-no-l btn-no-r"
          :class="activeMenu == 'tagged' ? 'btn-primary' : 'btn-secondary'"
        >
          Tagged
        </router-link>
        <router-link
          to="/integrations/campains"
          class="btn btn-no-l btn-secondary"
        >
          Ads
        </router-link>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <div class="nature-white-box">
          <div class="white-box-top"></div>
          <div class="row mt-3">
            <div class="col-md-4 col-lg-3">
              <div class="left-nav">
                <h2 class="semibold-16 mt-3 mb-1 ms-3">Pages</h2>
                <div class="items">
                  <button
                    v-for="page in pages.filter((e) => e.type == 1)"
                    :key="page.id"
                    class="btn w-100 text-start"
                    :class="
                      selectedPage?.id === page.id
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    "
                    v-on:click="selectService(page.integration_service, page)"
                  >
                    <BaseIcon
                      :name="getLogo(page.integration_service)"
                      type="social"
                      class="logo-icon"
                    />
                    <span>{{ page.name }}</span>
                    <span class="badge ms-3" :class="getTypeClass(page.type)">{{
                      getTypeName(page.type)
                    }}</span>
                  </button>
                </div>
              </div>
              <h2 class="semibold-16 mt-3 mb-1 ms-3">Platforms</h2>
              <div class="left-nav">
                <div class="items">
                  <button
                    class="btn w-100 text-start"
                    :class="
                      selectedService === 'Google' && selectedPage === null
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    "
                    v-on:click="selectService('Google')"
                  >
                    <BaseIcon
                      name="google-maps"
                      type="social"
                      class="logo-icon"
                    />
                    <span>Google</span>
                  </button>
                  <button
                    class="btn w-100 text-start"
                    :class="
                      selectedService === 'Facebook'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    "
                    v-on:click="selectService('Facebook')"
                  >
                    <BaseIcon name="facebook" type="social" class="logo-icon" />
                    <span>Facebook</span>
                  </button>
                  <button
                    class="btn w-100 text-start"
                    :class="
                      selectedService === 'TikTok'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    "
                    v-on:click="selectService('TikTok')"
                  >
                    <BaseIcon name="tiktok" type="social" class="logo-icon" />
                    <span>TikTok</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-8 col-lg-9">
              <div
                v-if="addNew && selectedService !== null"
                class="m-5 p-5 text-center"
              >
                <div class="bold-40">Connect an account</div>
                <p>Manage your data from Prodyflow</p>
                <template v-if="selectedService == 'TikTok'">
                  <button
                    class="btn btn-type-2 mt-4 me-2"
                    v-on:click="login('TikTokPersonal')"
                  >
                    <span>Connect Personal account</span>
                  </button>
                  <button
                    class="btn btn-type-2 mt-4"
                    v-on:click="login('TikTok')"
                  >
                    <span>Connect Ads account</span>
                  </button>
                </template>
                <template v-else>
                  <button class="btn btn-type-2 mt-4" v-on:click="login()">
                    <span>Connect account</span>
                  </button>
                </template>
              </div>
              <div v-else>
                <section v-if="activeMenu == 'feed'">
                  <div class="post-grid">
                    <div
                      v-for="post in filteredPosts"
                      :key="post.id"
                      class="post-card"
                    >
                      <div class="post-header d-flex align-items-center">
                        <div class="post-avatar">
                          <BaseIcon
                            :name="getLogo(post.integration_service)"
                            type="social"
                            class="logo-icon"
                          />
                        </div>

                        <div class="post-user-info flex-1-1-0">
                          <div class="post-username">{{ post.username }}</div>
                          <div class="post-date">
                            {{ formatDate(post.posted_at) }}
                          </div>
                        </div>
                        <div>
                          <div class="col-auto">
                            <label class="cstm-check dropdown-item">
                              <span class="text-black mx-2 regular-14">
                                Show in website
                              </span>
                              <input
                                type="checkbox"
                                v-model="post.show_in_website"
                                v-on:change="postShowInWebsite(post)"
                                :value="true"
                              />
                              <span class="checkmark mx-2"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="post-body">
                        <div class="post-text">{{ post.text }}</div>
                        <video
                          :src="post.media_url"
                          v-if="
                            post.media_url &&
                            post.media_url.indexOf('.mp4') > 0 &&
                            post.thumbnail_url == null
                          "
                          autoplay
                          muted
                        ></video>
                        <ImageAnnotorious
                          v-else-if="post.thumbnail_url"
                          :src="post.thumbnail_url"
                          :raw-points="post.IntegrationTagProductVariant"
                          class="post-image w-100"
                          v-on:save="
                            (data) => saveProductToMedia(post.id, data)
                          "
                        />
                        <ImageAnnotorious
                          v-else-if="post.media_url"
                          :src="post.media_url"
                          :raw-points="post.IntegrationTagProductVariant"
                          class="post-image w-100"
                          v-on:save="
                            (data) => saveProductToMedia(post.id, data)
                          "
                        />
                      </div>
                      <div
                        class="post-footer d-flex justify-content-between mt-3"
                      >
                        <div class="footer-box">
                          <span class="footer-count">{{
                            post.comments_count ?? "-"
                          }}</span>
                          <span class="footer-label">Comments</span>
                        </div>
                        <div class="footer-box">
                          <span class="footer-count">{{
                            post.likes_count ?? "-"
                          }}</span>
                          <span class="footer-label">Likes</span>
                        </div>
                        <div class="footer-box">
                          <span class="footer-count">{{
                            post.reshare_count ?? "-"
                          }}</span>
                          <span class="footer-label">Reshares</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section v-if="activeMenu == 'tagged'">
                  <div class="post-grid">
                    <div
                      v-for="post in filteredMentions"
                      :key="post.id"
                      class="post-card"
                    >
                      <div class="post-header d-flex align-items-center">
                        <div class="post-avatar">
                          <BaseIcon
                            :name="getLogo(post.integration_service)"
                            type="social"
                            class="logo-icon"
                          />
                        </div>

                        <div class="post-user-info flex-1-1-0">
                          <div class="post-username">{{ post.username }}</div>
                          <div class="post-date">
                            {{ formatDate(post.posted_at) }}
                          </div>
                        </div>
                        <div>
                          <div class="col-auto">
                            <label class="cstm-check dropdown-item">
                              <span class="text-black mx-2 regular-14">
                                Show in website
                              </span>
                              <input
                                type="checkbox"
                                v-model="post.show_in_website"
                                v-on:change="postShowInWebsite(post)"
                                :value="true"
                              />
                              <span class="checkmark mx-2"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="post-body">
                        <div class="post-text">{{ post.text }}</div>
                        <video
                          :src="post.media_url"
                          v-if="
                            post.media_url &&
                            post.media_url.indexOf('.mp4') > 0 &&
                            post.thumbnail_url == null
                          "
                          autoplay
                          muted
                        ></video>
                        <ImageAnnotorious
                          v-else-if="post.thumbnail_url"
                          :src="post.thumbnail_url"
                          :raw-points="post.IntegrationTagProductVariant"
                          class="post-image w-100"
                          v-on:save="
                            (data) => saveProductToMedia(post.id, data)
                          "
                        />
                        <ImageAnnotorious
                          v-else-if="post.media_url"
                          :src="post.media_url"
                          :raw-points="post.IntegrationTagProductVariant"
                          class="post-image w-100"
                          v-on:save="
                            (data) => saveProductToMedia(post.id, data)
                          "
                        />
                      </div>
                      <div
                        class="post-footer d-flex justify-content-between mt-3"
                      >
                        <div class="footer-box">
                          <span class="footer-count">{{
                            post.comments_count ?? "-"
                          }}</span>
                          <span class="footer-label">Comments</span>
                        </div>
                        <div class="footer-box">
                          <span class="footer-count">{{
                            post.likes_count ?? "-"
                          }}</span>
                          <span class="footer-label">Likes</span>
                        </div>
                        <div class="footer-box">
                          <span class="footer-count">{{
                            post.reshare_count ?? "-"
                          }}</span>
                          <span class="footer-label">Reshares</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import ws from "@/modules/ws";
import http from "@/modules/http";
import date from "@/modules/date";
import BaseIcon from "../../../components/icons/BaseIcon.vue";
import ImageAnnotorious from "../../../components/ImageAnnotorious.vue";

export default {
  name: "Posts",
  components: { ImageAnnotorious, BaseIcon },
  data() {
    return {
      store: useStore(),
      services: [],
      pages: [],
      data: [],
      posts: [],
      mentions: [],
      selectedService: null,
      selectedPage: null,
      addNew: false,
    };
  },
  computed: {
    activeMenu() {
      return this.$route.params.type;
    },
    warehouses() {
      return this.store.state.warehouses;
    },
    path() {
      return this.$route.path;
    },
    filteredPosts() {
      if (this.selectedPage === null) {
        return this.posts;
      }
      return this.posts.filter(
        (post) => post.integration_page_id === this.selectedPage.id
      );
    },
    filteredMentions() {
      if (this.selectedPage === null) {
        return this.mentions;
      }
      return this.mentions.filter(
        (post) => post.integration_page_id === this.selectedPage.id
      );
    },
  },
  mounted() {
    this.loadData();

    ws.init();

    ws.subscribe("add", "contactMessage", (e) => {
      if (e.session !== this.sessionId) {
        this.messages.push(e.object);
        this.tableKey++;
      }
    });
  },
  methods: {
    getLogo(name) {
      switch (name) {
        case "google":
          return "google-maps";
        default:
          return name;
      }
    },
    getTypeClass(type) {
      switch (type) {
        case 1:
          return "primary";
        case 2:
          return "failed";
        case 3:
          return "light";
        default:
          return "";
      }
    },
    getTypeName(type) {
      switch (type) {
        case 1:
          return "Feed";
        case 2:
          return "Ads";
        case 3:
          return "Location";
        default:
          return "";
      }
    },
    formatDate(val) {
      return date.format(val, true, false);
    },
    login(service = null) {
      http
        .fetch(`/service-integrations/login/${service ?? this.selectedService}`)
        .then((data) => {
          location.href = data.redirect;
        });
    },
    saveProductToMedia(id, data) {
      http.fetch(`/service-integrations/tags/${id}/add-product`, {
        pos_x: data.pos_x,
        pos_y: data.pos_y,
        product_variant_id: data.product.variant_id,
      });
    },
    loadData() {
      let url = "/service-integrations/tags";
      http.fetch(url).then((data) => {
        this.services = data.services;
        this.pages = data.pages;
        this.rating = data.rating;
        this.posts = data.posts;
        this.mentions = data.mentions;
      });
    },
    selectService(service, page = null) {
      if (service == "instagram") {
        service = "facebook";
      } else if (service == "tiktok") {
        service = "TikTok";
      }

      service = service.charAt(0).toUpperCase() + service.slice(1);

      this.selectedService = service;
      this.selectedPage = page;
      this.addNew = false;
      if (service === "TikTok") {
        if (this.services["TikTokPersonal"] || this.services["TikTok"]) {
          this.loadBasicData();
        } else {
          this.addNew = true;
        }
      } else if (this.services[service]) {
        this.loadBasicData();
      } else {
        this.addNew = true;
      }
    },
    loadBasicData() {
      http
        .fetch(`/service-integrations/basic/${this.selectedService}`)
        .then((data) => {
          this.data[this.selectedService] = data;
        });
    },
    postShowInWebsite(post) {
      http.fetch(`/service-integrations/tags/${post.id}`, {
        show_in_website: post.show_in_website,
      });
    },
  },
};
</script>
<style scoped>
.post-grid {
  display: grid;
  grid-template-columns: 50% 50%;
  align-content: center;
  gap: 1em;
  width: calc(100% - 1em);
}

.post-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
}

.post-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.post-header {
  gap: 12px;
  margin-bottom: 12px;
}

.post-avatar {
  height: 42px;
  width: 42px;
  border-radius: 50%;
  overflow: hidden;
  background: #f3f3f3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-icon {
  width: 28px;
  height: 28px;
}

.post-user-info {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.post-username {
  font-weight: 600;
  font-size: 0.95rem;
  color: #222;
}

.post-date {
  font-size: 0.75rem;
  color: #777;
}

.post-text {
  margin-bottom: 10px;
  white-space: pre-line;
  font-size: 0.95rem;
  overflow: hidden;
}

.post-card video {
  max-height: 44em;
  margin: 0 auto;
  display: block;
}

.post-image {
  margin-top: 8px;
  width: 100%;
  text-align: center;
}

.post-body {
  flex: 1 1 0;
  text-wrap: wrap;
}

.post-footer {
  border-top: 1px solid #e5e7eb;
  padding-top: 10px;
}

.footer-box {
  flex: 1;
  text-align: center;
  cursor: pointer;
  transition: background 0.2s;
  padding: 6px 0;
  border-radius: 6px;
}

.footer-box:hover {
  background: #f3f4f6;
}

.footer-count {
  display: block;
  font-weight: 600;
  color: #111;
}

.footer-label {
  display: block;
  font-size: 0.8rem;
  color: #777;
}
</style>
